<template>
  <span class="color-text-none">{{ displayedText }}</span>
</template>

<script>
export default {
  name: 'NoDataText',
  props: {
    text: {
      type: String,
      default: 'none'
    }
  },
  computed: {
    displayedText () {
      return this.text
    }
  }
}
</script>
